import { render } from "./FatturazioneView.vue?vue&type=template&id=6561e00c&scoped=true"
import script from "./FatturazioneView.vue?vue&type=script&lang=js"
export * from "./FatturazioneView.vue?vue&type=script&lang=js"

import "./FatturazioneView.vue?vue&type=style&index=0&id=6561e00c&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6561e00c"]])

export default __exports__